import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'mail',
    templateUrl: './mail.component.html',
    styleUrls: ['./mail.component.scss'],
    standalone: false
})
export class MailComponent extends EaSubscriptionBuilder implements OnInit {
  sessionConsultant = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
    // new add
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    const pledge = this.subscriptionFacade.getPledge();
    this.sessionConsultant =
      !!pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }
  next() {}

  prev() {
    this.subscriptionFacade.previousStep();
  }
  notifyClick() {
    this.subscriptionFacade.notifyClick();
  }
}
